// src/api/unit.ts
import { apiClient } from "../helpers/api_helper";

export interface Unit {
  id: number;
  name: string;
  description?: string;
  contact_person?: string;
  contact_phone?: string;
  short_name?: string;
  location?: string;
  status: boolean;
  created_at: string;
  updated_at: string;
}

export const fetchUnits = async (includeInactive: boolean = false) => {
  const response = await apiClient.get(
    `/units?include_inactive=${includeInactive}`,
  );
  return response.data;
};
